export default "__VITE_ASSET__ede3beb2__"